import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AgeRange from '../components/AgeRange'
import { VotingExtendAge, VotingButtons } from '../components/Voting'
import { vote } from '../state/actions/valentine'
import { setRange } from '../state/actions/ageRange'

const Photo = (props) => <div>
  <div className='pal-userphoto-container'>
    <a href={`/narys.cfm?narys=${props.valentine.id}`} className="pal-userphoto-link" target="_blank"><img src={props.valentine.photo} alt="" className="pal-userphoto" /></a>
    {props.valentine.photoCount > 0 ? <a href={`/foto/?narys=${props.valentine.id}`} target="_blank" className="pal-userphoto-count"><img src="//img.draugas.lt/images/fotoaparatas3.gif" /><span>{props.valentine.photoCount}</span></a> : null}
  </div>
  <div className="pal-username"><a href={`/narys.cfm?narys=${props.valentine.id}`}>{props.valentine.name}, {props.valentine.age}</a></div>
</div>

const NoPhoto = (props) => <div>
  <div className='pal-userphoto-container'>
    <div className='pal-userphoto-link'><img src='//img.draugas.lt/images/question_nophoto.png' className='pal-userphoto' /></div>
  </div>
</div>

const Loading = ({ gameType }) => <div>
  <a className="pal-userphoto-loading"><img src={gameType == 1 || gameType == 2 ? '//img.draugas.lt/images/loading6.gif' : '/dotnet/question/img/3/loading.gif'} alt="" /></a>
</div>

@connect(
  state => ({
    loading: state.loading,
    valentine: state.valentine,
    ageRange: state.ageRange
  }),
  dispatch => bindActionCreators({ vote, setRange }, dispatch)
)
export default class Valentine extends Component {

  static defaultProps = {
    ageSliderVisible: true
  }

  vote(value) {

    const { loading, vote, onVoted, gameType } = this.props

    if (loading) return
    vote(gameType, value, onVoted)
  }

  render() {
    const { valentine, loading, ageSliderVisible, setRange, ageRange, player, gameType } = this.props

    const photoPartial = valentine.id == '0'
      ? <NoPhoto />
      : <Photo valentine={valentine} />

    const buttonsPartial = valentine.id == '0'
      ? <VotingExtendAge vote={this.vote.bind(this)} />
      : <VotingButtons vote={this.vote.bind(this)} nextButtonCaption={player.sex == 1 ? 'KITAS' : 'KITA'} />

    return <div>
      {loading ? <Loading gameType={gameType} /> : photoPartial}
      {buttonsPartial}
      {ageSliderVisible ? <AgeRange setRange={setRange} ageRange={ageRange} /> : null}
    </div>
  }
}

